import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { useLocalization } from '../../../../context/Localization/localization';
import { LocalizationType } from '../../../../context/Localization/localization.types';
import { GMAppointmentName } from '../../../../controls/AppointmentName';
import { Heading } from '../../../../controls/Heading/Heading';
import { TransportationButtonList } from '../../../../controls/TransportationButtonList/TransportationButtonList';
import { ScrollableBody } from '../../../Layout/ScrollableBody/ScrollableBody';
import { TransportationOptionsProps } from './TransportationOptions.types';

/**
 * Renders transportation for when the service lane is open.
 *
 * @param onProceed - {@link TransportationOptionsProps.onProceed onProceed} description.
 * @param transportationOptions - {@link TransportationOptionsProps.transportationOptions transportationOptions} description.
 */
export const TransportationOptions: GoMotoComponent<TransportationOptionsProps> = ({
    onProceed,
    transportationOptions,
}) => {
    const Localization: LocalizationType = useLocalization();

    return (
        <ScrollableBody
            heading={
                <Heading
                    primaryHeading={<GMAppointmentName />}
                    secondaryHeading={Localization.DoYouNeedAlternateTransportationToday}
                    leftAlign
                />}
            topDivider
        >
            <TransportationButtonList
                transportationOptions={transportationOptions}
                onClick={onProceed}
            />
        </ScrollableBody>
    );
};